import { Injectable } from '@angular/core';
import { IPaginationInfo } from '../models/common.model';

@Injectable({
    providedIn: 'root'
})
export class PagerService {
    public getRange(start, end, step?) {
        const range = [];
        const typeofStart = typeof start;
        const typeofEnd = typeof end;

        if (step === 0) {
            throw TypeError('Step cannot be zero.');
        }

        if (typeofStart === 'undefined' || typeofEnd === 'undefined') {
            throw TypeError('Must pass start and end arguments.');
        } else if (typeofStart !== typeofEnd) {
            throw TypeError('Start and end arguments must be of same type.');
        }

        if (end < start) {
            step = -step;
        }

        if (typeofStart === 'number') {
            while (step > 0 ? end >= start : end <= start) {
                range.push(start);
                start += step;
            }
        } else if (typeofStart === 'string') {
            if (start.length !== 1 || end.length !== 1) {
                throw TypeError('Only strings with one character are supported.');
            }

            start = start.charCodeAt(0);
            end = end.charCodeAt(0);

            while (step > 0 ? end >= start : end <= start) {
                range.push(String.fromCharCode(start));
                start += step;
            }
        } else {
            throw TypeError('Only string and number types are supported');
        }

        return range;
    }

    public getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10): IPaginationInfo {
        // calculate total pages
        const totalPages = Math.ceil(totalItems / pageSize);

        let startPage: number, endPage: number;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        const startIndex = currentPage * pageSize;
        const endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
        // create an array of pages to ng-repeat in the pager control
        const pages = this.getRange(startPage, endPage);
        // let pages = _.range(startPage, endPage + 1);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex
            // pages: pages
        };
    }
}
